import React from 'react';
import './LoginLayout.scss';

interface ILoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: React.FC<ILoginLayoutProps> = props => {
  return <main>{props.children}</main>;
};

export default LoginLayout;
